import Modal from "@material-ui/core/Modal";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, makeStyles } from "@material-ui/core";
import React from "react";
import Button from "./button";
import { infoIcon } from "./icons-svg";

export default function InfoModal(props) {
    return (
        <>
            <Dialog
                open={props.open}
                onClose={() => props.onClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <div
                    css="display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    padding-left: 8px;
                    ">
                        {infoIcon}
                        <DialogTitle id="info-title">{props.title}</DialogTitle>
                </div>

                <DialogContent>
                    <DialogContentText id="alert-dialog-description" color="textPrimary">
                        {props.message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => props.onConfirm()}>
                        <span css={'white-space:nowrap;'}>Ok</span>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )

}